import { render, staticRenderFns } from "./FacilitySettingTab.vue?vue&type=template&id=2f39cb60&scoped=true&lang=pug"
import script from "./FacilitySettingTab.vue?vue&type=script&lang=ts"
export * from "./FacilitySettingTab.vue?vue&type=script&lang=ts"
import style0 from "./FacilitySettingTab.vue?vue&type=style&index=0&id=2f39cb60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f39cb60",
  null
  
)

export default component.exports